import { PooledBenchmarkPhase2UnivService } from "../service/asyncBatchPooledBenchmarkPhase2UnivService";
import * as validations from "../utils/validations";

export class PooledBenchmarkPhase2UnivFunctions {
  fnBurgissCalcPooledBenchmarkDPIByWeight(
    universe: string = null,
    weight: string = null,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (reportvaluation == 1 || reportvaluation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    return new PooledBenchmarkPhase2UnivService().burgissCalcPooledBenchmarkDPIByWeight(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkTVPIByWeight(
    universe: string = null,
    weight: string = null,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (reportvaluation == 1 || reportvaluation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    return new PooledBenchmarkPhase2UnivService().burgissCalcPooledBenchmarkTVPIByWeight(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }

  fnBurgissCalcPooledBenchmarkRVPIByWeight(
    universe: string = null,
    weight: string = null,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (reportvaluation == 1 || reportvaluation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    return new PooledBenchmarkPhase2UnivService().burgissCalcPooledBenchmarkRVPIByWeight(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkDPIByCommitment(
    universe: string = null,
    weight: string = null,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (reportvaluation == 1 || reportvaluation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    return new PooledBenchmarkPhase2UnivService().burgissCalcPooledBenchmarkDPIByCommitment(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkTVPIByCommitment(
    universe: string = null,
    commitment: string = null,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramCommitment = validations.ValidateByCommitment(commitment, "Commitment");

    if (String(paramCommitment).includes("Error")) {
      return "#INVALIDPARAMETERS - Commitment is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (reportvaluation == 1 || reportvaluation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    return new PooledBenchmarkPhase2UnivService().burgissCalcPooledBenchmarkTVPIByCommitment(
      paramUniverse,
      paramCommitment,
      baseorlocalcurrency,
      alternateCurrrency,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkRVPIByCommitment(
    universe: string = null,
    commitment: string = null,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramcommitment = validations.ValidateByCommitment(commitment, "Commitment");

    if (String(paramcommitment).includes("Error")) {
      return "#INVALIDPARAMETERS - Commitment is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (reportvaluation == 1 || reportvaluation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    return new PooledBenchmarkPhase2UnivService().burgissCalcPooledBenchmarkRVPIByCommitment(
      paramUniverse,
      paramcommitment,
      baseorlocalcurrency,
      alternateCurrrency,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
}
